import * as LucideIcons from "lucide-react";
import { useEffect, useState } from "react";

import { fetchHomeSection, HomeSection } from "@/services/homeService";

export default function SafetySection() {
  const [section, setSection] = useState<HomeSection<any> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHomeSection("safety").then((data) => {
      setSection(data);
      setLoading(false);
    });
  }, []);

  // Modern shimmer for loading
  function ModernShimmer({
    className = "",
    height,
    width,
  }: {
    className?: string;
    height: string;
    width: string;
  }) {
    return (
      <div
        className={`relative overflow-hidden rounded-xl shadow-sm ${className}`}
        style={{ height, width }}
      >
        <div
          className="animate-shimmer absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 dark:from-base-200 dark:via-base-100 dark:to-base-200"
          style={{ backgroundSize: "200% 100%" }}
        />
      </div>
    );
  }

  if (
    typeof document !== "undefined" &&
    !document.getElementById("modern-shimmer-style")
  ) {
    const style = document.createElement("style");
    style.id = "modern-shimmer-style";
    style.innerHTML = `
      @keyframes shimmer {
        0% { background-position: -200% 0; }
        100% { background-position: 200% 0; }
      }
      .animate-shimmer {
        animation: shimmer 1.5s linear infinite;
      }
    `;
    document.head.appendChild(style);
  }

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-16">
      {loading ? (
        <>
          <ModernShimmer className="mx-auto mb-4" height="3rem" width="60%" />
          <ModernShimmer className="mx-auto mb-10" height="2rem" width="80%" />
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {[...Array(3)].map((_, i) => (
              <ModernShimmer
                className="mx-auto max-w-md"
                height="260px"
                key={i}
                width="100%"
              />
            ))}
          </div>
        </>
      ) : section && section.content ? (
        <>
          <h2 className="mb-4 text-center text-3xl font-extrabold text-primary md:text-5xl">
            {section.content.title}
          </h2>
          <p className="mx-auto mb-10 max-w-2xl text-center text-lg text-base-content/70">
            {section.content.subtitle}
          </p>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {section.content.features?.map((feature: any, i: number) => {
              const Icon = LucideIcons[
                feature.icon as keyof typeof LucideIcons
              ] as any;
              return (
                <div
                  className="flex flex-col items-center rounded-2xl bg-base-200 p-8 text-center shadow transition hover:shadow-lg"
                  key={feature.title + i}
                >
                  <div className="mb-4">
                    {Icon ? <Icon className="text-primary" size={48} /> : null}
                  </div>
                  <div className="mb-2 text-xl font-bold">{feature.title}</div>
                  <div className="text-base-content/70">
                    {feature.description}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : null}
    </section>
  );
}
